import React from 'react';
import { useParams, useNavigate} from "react-router-dom";
import Chapter from "./Chapter"

export default function PageBook() {
  let params = useParams();
  let navigate = useNavigate();

    return <Chapter bookKey={params.bookKey} chapterKey={params.chapterKey} navigate={navigate}/>
  }